<template>
<div class="chapter">
<div class="inner_page">
<p class="poem1" id="dedication">for two who</p>
<p class="poem1">slipped away</p>
<p class="poem1">almost</p>
<p class="poem1">entirely:</p>
<p class="poem1">my “part” Cherokee</p>
<p class="poem1">great-grandmother</p>
<p class="poem1">Tallulah</p>
<p class="poem1">(Grandmama Lula)</p>
<p class="poem1">on my mother’s side</p>
<p class="poem1">about whom</p>
<p class="poem1">only one</p>
<p class="poem1">agreed-upon</p>
<p class="poem1">thing</p>
<p class="poem1">is known:</p>
<p class="poem1">her hair was so long</p>
<p class="poem1">she could sit on it;</p>
<p class="poem1" style="margin-top:20px;">and my white (Anglo-Irish?)</p>
<p class="poem1">great-great-grandfather</p>
<p class="poem1">on my father’s side;</p>
<p class="poem1">nameless</p>
<p class="poem1">(Walker, perhaps?),</p>
<p class="poem1">whose only remembered act</p>
<p class="poem1">is that he raped</p>
<p class="poem1">a child:</p>
<p class="poem1">my great-great-grandmother,</p>
<p class="poem1">who bore his son,</p>
<p class="poem1">my great-grandfather,</p>
<p class="poem1">when she was eleven.</p>
<p class="poem1" style="margin-top:20px;">Rest in peace.</p>
<p class="poem1">The meaning of your lives</p>
<p class="poem1">is still</p>
<p class="poem1">unfolding.</p>
<p class="poem1" style="margin-top:20px;">Rest in peace.</p>
<p class="poem1">In me</p>
<p class="poem1">the meaning of your lives</p>
<p class="poem1">is still</p>
<p class="poem1">unfolding.</p>
<p class="poem1" style="margin-top:20px;">Rest in peace, in me.</p>
<p class="poem1">The meaning of your lives</p>
<p class="poem1">is still</p>
<p class="poem1">unfolding.</p>
<p class="poem1" style="margin-top:20px;">Rest. In me</p>
<p class="poem1">the meaning of your lives</p>
<p class="poem1">is still</p>
<p class="poem1">unfolding.</p>
<p class="poem1" style="margin-top:20px;">Rest. In peace</p>
<p class="poem1">in me</p>
<p class="poem1">the meaning</p>
<p class="poem1">of our lives</p>
<p class="poem1">is still</p>
<p class="poem1">unfolding.</p>
<p class="poem1" style="margin-top:20px;">Rest.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?3e3f980e